import { jsxs as n, jsx as r } from "react/jsx-runtime";
import { useState as x, useMemo as p } from "react";
import a from "./index.es5616.js";
import { BodyText as c } from "./index.es505.js";
import { BulletSeparator as y } from "./index.es515.js";
import { UtilityChevronIcon as f } from "./index.es439.js";
const N = "collapsible-paragraph-component", $ = ({
  text: s,
  size: e,
  testId: o
}) => /* @__PURE__ */ n("div", { className: a.itemContainer, "data-testid": o, children: [
  /* @__PURE__ */ r("div", { className: a.iconWrapper, children: /* @__PURE__ */ r(y, {}) }),
  /* @__PURE__ */ r(c, { size: e, isEllipsis: !0, children: s })
] }), S = ({
  title: s,
  paragraphContent: e,
  size: o = "small",
  defaultOpen: h = !0,
  isCollapsible: d = !0,
  testId: l = N
}) => {
  const [i, u] = x(d ? h : !0), v = () => {
    u((t) => !t);
  }, g = p(
    () => i && Array.isArray(e),
    [i, e]
  ), w = p(
    () => i && !Array.isArray(e),
    [i, e]
  );
  return /* @__PURE__ */ n(
    "div",
    {
      className: a.container,
      "data-testid": l,
      id: `${l}-expandable-paragraph`,
      children: [
        /* @__PURE__ */ n("div", { className: a.row, children: [
          /* @__PURE__ */ r(c, { size: o, isEllipsis: !i, children: s }),
          d && /* @__PURE__ */ r(
            "button",
            {
              className: a.right,
              onClick: v,
              "aria-controls": `${l}-expandable-paragraph`,
              "aria-expanded": i,
              "aria-label": `chevron-toggle-${i ? "up" : "down"}`,
              "data-testid": `${l}-chevron-toggle`,
              children: /* @__PURE__ */ r(f, { direction: i ? "up" : "down" })
            }
          )
        ] }),
        g && e.map((t, m) => /* @__PURE__ */ r($, { text: t, size: o }, `${l}-${m}`)),
        w && /* @__PURE__ */ r("div", { className: a.itemContainer, children: /* @__PURE__ */ r(c, { size: o, children: e }) })
      ]
    }
  );
};
export {
  $ as BulletPointItem,
  S as CollapsibleParagraph,
  N as DEFAULT_TEST_ID
};
//# sourceMappingURL=index.es864.js.map
